import { Card, Grid } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Title } from "../../components";
import { H6 } from "../../components/NormalFonts";
import { useLayout } from "../../context/LayoutContext";
import { ContentWrapper } from "../../layouts/components";
import { envChangeType } from "../../plugins/utils";
import styles from "./styleModule";
import "./styles.scss";

const Guide = () => {
  const { t } = useTranslation();
  const { getHeaderHeight } = useLayout();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  useEffect(() => {
    window.location.href = `${envChangeType("REACT_APP_MAIN_URL")}/news/detail/14`;
  }, []);

  return (
    <ContentWrapper>
      <div
        className={`${styles.guide} ${screens.sm ? "" : styles.mobile} guide`}
        style={{ "--marginTop": getHeaderHeight() } as React.CSSProperties}
      >
        <Title title={t("guide.title")} subtitle={t("guide.subtitle")} />
        <div
          className={styles.contentContainer}
          style={{ gap: screens.xs ? 16 : 24 }}
        >
          {Array.from({ length: 4 }, (_, i) => (
            <Card
              style={{ width: "100%" }}
              size={screens.sm ? "default" : "small"}
              title={
                <H6
                  className={styles.title}
                  color=" var(--text-content-1)"
                  weight="medium"
                >
                  {t(`guide.section${i + 1}.title`, {
                    name: process.env.REACT_APP_PROD_NAME_DISPLAY,
                  })}
                </H6>
              }
              variant="borderless"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: t(`guide.section${i + 1}.content`, {
                    name: process.env.REACT_APP_PROD_NAME_DISPLAY,
                  }),
                }}
                className={`${styles.content}`}
              />
            </Card>
          ))}
        </div>
      </div>
    </ContentWrapper>
  );
};

export default Guide;
